import './ViewerPanel.scss';

import ViewerPanel from './ViewerPanel';
import {
  getPushPinSchema,
  pushPinUiSchema,
  getViewerPanelSchema,
  getViewerPanelAdminSchema,
  viewerPanelUiSchema,
} from './viewerPanelSchema';

export {
  ViewerPanel,
  getPushPinSchema,
  pushPinUiSchema,
  getViewerPanelSchema,
  getViewerPanelAdminSchema,
  viewerPanelUiSchema,
};
